import {Injectable} from "@angular/core";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {GjeldendeLokale} from "felles-ng2/tjenester/i18n/GjeldendeLokale";
import {MatPaginatorIntl} from "@angular/material/paginator";

/**
 * paginator i material
 *
 * Se hhttps://material.angular.io/components/paginator/overview#internationalization
 */
@Injectable()
export class MatPaginatorOversettelse extends MatPaginatorIntl {

    constructor(private oversettelser: Oversettelser, gjeldendeLokale: GjeldendeLokale) {
        super();
        gjeldendeLokale.brukersLokaleSomStrøm().subscribe(() => this.oppdaterOptionalLabel())
    }

    oppdaterOptionalLabel() {
        this.itemsPerPageLabel = this.oversettelser.oversett(i18n('Antall per side'));
        this.nextPageLabel = this.oversettelser.oversett(i18n('Neste side'));
        this.previousPageLabel = this.oversettelser.oversett(i18n('Forrige side'));
        this.firstPageLabel = this.oversettelser.oversett(i18n('Første side'));
        this.lastPageLabel = this.oversettelser.oversett(i18n('Siste side'));
        this.getRangeLabel = (page: number, pageSize: number, length: number) => {
            // 6 – 10 of 20 dette er default
            let førsteTreff: number = (page * pageSize) + 1;
            let sisteTreff: number = Math.min(((page + 1) * pageSize), length);
            return this.oversettelser.oversett(i18n('Viser {førsteTreff} - {sisteTreff} av {totalAntallSider}'), {førsteTreff: førsteTreff, sisteTreff: sisteTreff, totalAntallSider: length})
        };

        // Required for the optional label text to be updated
        // Notifies the MatPaginatorIntl service that a change has been made
        this.changes.next();
    }
}
